/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface PlanLocalisationSearch
 */
export interface PlanLocalisationSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationSearch
     */
    anneeAcademique?: TextSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof PlanLocalisationSearch
     */
    centre?: StringListSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationSearch
     */
    dateValidation?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof PlanLocalisationSearch
     */
    statutLocalisationAgrement?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlanLocalisationSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof PlanLocalisationSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof PlanLocalisationSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PlanLocalisationSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof PlanLocalisationSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PlanLocalisationSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the PlanLocalisationSearch interface.
 */
export function instanceOfPlanLocalisationSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PlanLocalisationSearchFromJSON(json: any): PlanLocalisationSearch {
    return PlanLocalisationSearchFromJSONTyped(json, false);
}

export function PlanLocalisationSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanLocalisationSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anneeAcademique': !exists(json, 'anneeAcademique') ? undefined : TextSearchFromJSON(json['anneeAcademique']),
        'centre': !exists(json, 'centre') ? undefined : StringListSearchFromJSON(json['centre']),
        'dateValidation': !exists(json, 'dateValidation') ? undefined : TextSearchFromJSON(json['dateValidation']),
        'statutLocalisationAgrement': !exists(json, 'statutLocalisationAgrement') ? undefined : TextSearchFromJSON(json['statutLocalisationAgrement']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function PlanLocalisationSearchToJSON(value?: PlanLocalisationSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anneeAcademique': TextSearchToJSON(value.anneeAcademique),
        'centre': StringListSearchToJSON(value.centre),
        'dateValidation': TextSearchToJSON(value.dateValidation),
        'statutLocalisationAgrement': TextSearchToJSON(value.statutLocalisationAgrement),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

